import { render, staticRenderFns } from "./File.vue?vue&type=template&id=049ba773&scoped=true&"
import script from "./File.vue?vue&type=script&lang=js&"
export * from "./File.vue?vue&type=script&lang=js&"
import style0 from "./File.vue?vue&type=style&index=0&id=049ba773&prod&scoped=true&lang=css&"
import style1 from "./File.vue?vue&type=style&index=1&id=049ba773&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049ba773",
  null
  
)

export default component.exports